import React from 'react';
import AnalyticsPage from './AnalyticsPage';

const AnalyticsDashboard: React.FC = () => {
  return <AnalyticsPage />;
};

export default AnalyticsDashboard; 